import Vue from 'vue';
import VueResource from 'vue-resource';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

export default {
  aplicacoesFinanceiras: filtros => {
    return Vue.http.get('/api/relatorioaplicacoesfinanceiras',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idConta: filtros.idConta,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          rendimentoLiquido: filtros.rendimentoLiquido,
        }
      })
    .then(resposta => resposta.body);
  },
  aplicacoesFinanceirasExcel: filtros => {
    return Vue.http.get('/api/relatorioaplicacoesfinanceiras/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idConta: filtros.idConta,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          rendimentoLiquido: filtros.rendimentoLiquido,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  contasPagarReceber: filtros => {
    return Vue.http.get('/api/relatoriocontaspagarreceber',
      {
        params: {
          contasPagar: filtros.contasPagar,
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          tipo: filtros.tipo,
        }
      })
      .then(resposta => resposta.body);
  },
  contasPagarReceberExcel: filtros => {
    return Vue.http.get('/api/relatoriocontaspagarreceber/Excel',
      {
        params: {
          contasPagar: filtros.contasPagar,
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          tipo: filtros.tipo,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  controleItem: filtros => {
    return Vue.http.get('/api/relatoriocontroleitem',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        }
      })
      .then(resposta => resposta.body);
  },
  controleItemExcel: filtros => {
    return Vue.http.get('/api/relatoriocontroleitem/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  protocolos: protocolo => {
    return Vue.http.get('/api/relatorioprotocolos',
      {
        params: {
          protocolo
        }
      })
    .then(resposta => resposta.body);
  },
  rubricasSintetico: filtros => {
    return Vue.http.get('/api/relatoriorubricas/sintetico',
      {
        params: filtros
      })
      .then(resposta => resposta.body);
  },
  rubricasAnalitico: filtros => {
    return Vue.http.get('/api/relatoriorubricas/analitico',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idConta: filtros.idConta,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idMetaEtapa: filtros.idMetaEtapa,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        }
      })
      .then(resposta => resposta.body);
  },
  impostos: filtros => {
    return Vue.http.get('/api/relatorioimpostos',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
        }
      })
    .then(resposta => resposta.body);
  },
  impostosExcel: filtros => {
    return Vue.http.get('/api/relatorioimpostos/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  verificacaoDePagamentos: filtros => {
    return Vue.http.get('/api/relatorioverificacaodepagamentos',
      {
        params: {
          campoDeBusca: filtros.campoDeBusca,
          termoDeBusca: filtros.termoDeBusca,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idProjeto: filtros.idProjeto,
        }
      })
    .then(resposta => resposta.body);
  },
  verificacaoDePagamentosExcel: filtros => {
    return Vue.http.get('/api/relatorioverificacaodepagamentos/Excel',
      {
        params: {
          campoDeBusca: filtros.campoDeBusca,
          termoDeBusca: filtros.termoDeBusca,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idProjeto: filtros.idProjeto,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  verificacaoDePagamentosFornecedor: filtros => {
    return Vue.http.get('/api/relatorioverificacaodepagamentosfornecedor',
      {
        params: {
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idProjeto: filtros.idProjeto,
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentosCambio: filtros => {
    return Vue.http.get('/api/relatoriolancamentoscambio',
        {
          params: {
            idProjeto: filtros.idProjeto,
            dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            idRubrica: filtros.idRubrica,
            idSubrubrica: filtros.idSubrubrica,
          }
        })
      .then(resposta => resposta.body);
  },
  pedidosCompra: filtros => {
    return Vue.http.get('/api/relatoriopedidoscompra',
        {
          params: {
            idProjeto: filtros.idProjeto,
            dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            idSolWebCompra: filtros.idSolWebCompra,
            idSolWebPassagem: filtros.idSolWebPassagem,
            numeroPedidoCompra: filtros.numeroPedidoCompra,
          }
        })
      .then(resposta => resposta.body);
  },
  pedidosCompraExcel: filtros => {
    return Vue.http.get('/api/relatoriopedidoscompra/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idSolWebCompra: filtros.idSolWebCompra,
          idSolWebPassagem: filtros.idSolWebPassagem,
          numeroPedidoCompra: filtros.numeroPedidoCompra,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  mensalidadesAgrupadoPorAluno: filtros => {
    return Vue.http.get('/api/relatoriomensalidadesagrupadoporaluno',
        {
          params: {
            idAluno: filtros.idAluno,
            idCurso: filtros.idCurso,
            idTurma: filtros.idTurma,
            idSituacao: filtros.idSituacao,
            dataVencimentoInicio: filtros.porVencimento ? moment(filtros.dataVencimentoInicio, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
            dataVencimentoFim: filtros.porVencimento ? moment(filtros.dataVencimentoFim, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
            dataPagamentoInicio: filtros.porPagamento ? moment(filtros.dataPagamentoInicio, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
            dataPagamentoFim: filtros.porPagamento ? moment(filtros.dataPagamentoFim, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
          }
        })
      .then(resposta => resposta.body);
  },
  mensalidadesAgrupadoPorAlunoExcel: filtros => {
    return Vue.http.get('/api/relatoriomensalidadesagrupadoporaluno/Excel',
      {
        params: {
          idAluno: filtros.idAluno,
          idCurso: filtros.idCurso,
          idTurma: filtros.idTurma,
          idSituacao: filtros.idSituacao,
          dataVencimentoInicio: filtros.porVencimento ? moment(filtros.dataVencimentoInicio, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
          dataVencimentoFim: filtros.porVencimento ? moment(filtros.dataVencimentoFim, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
          dataPagamentoInicio: filtros.porPagamento ? moment(filtros.dataPagamentoInicio, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
          dataPagamentoFim: filtros.porPagamento ? moment(filtros.dataPagamentoFim, 'DD/MM/YYYY').format('MM/DD/YYYY') : null,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  
  
  saldos: idProjeto => {
    return Vue.http.get('/api/relatoriosaldos',
        {
          params: {
            idProjeto
          }
        })
      .then(resposta => resposta.body);
  },
  lancamentos: filtros => {
    return Vue.http.get('/api/RelatorioLancamentos',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          rendimento: filtros.rendimento,
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentosExcel: filtros => {
    return Vue.http.get('/api/RelatorioLancamentos/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          rendimento: filtros.rendimento,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return ''; 
        
        return salvarArquivo(response);
      });
  },
  lancamentosModelo3: filtros => {
    return Vue.http.get('/api/RelatorioLancamentosModelo3',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          completo: (filtros.completo === 'true'),
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentosResumo: filtros => {
    return Vue.http.get('/api/RelatorioLancamentos/Resumo',
      {
        params: {
          idProjeto: filtros.idProjeto,
          rendimento: filtros.rendimento,
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentosResumoExcel: filtros => {
    return Vue.http.get('/api/RelatorioLancamentos/ResumoExcel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          rendimento: filtros.rendimento,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  lancamentosProjeto: filtros => {
    return Vue.http.get('/api/RelatorioLancamentos/Projetos',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idGrupo: filtros.idGrupo,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        }
      })
      .then(resposta => resposta.body);
  },
  lancamentosProjetoExcel: filtros => {
    return Vue.http.get('/api/RelatorioLancamentos/ProjetosExcel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idGrupo: filtros.idGrupo,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  subrubricasSintetico: filtros => {
    return Vue.http.get('/api/RelatorioSubrubricas/Sintetico',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
        }
      })
      .then(resposta => resposta.body);
  },
  subrubricasAnalitico: filtros => {
    return Vue.http.get('/api/RelatorioSubrubricas/Analitico',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
        }
      })
      .then(resposta => resposta.body);
  },
  subrubricasAnaliticoExcel: filtros => {
    return Vue.http.get('/api/RelatorioSubrubricas/Analitico/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idConta: filtros.idConta,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  provisoesProjeto: filtros => {
    return Vue.http.get('/api/relatorioprovisoesprojeto',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          tipo: filtros.tipoProvisao,
          situacao: filtros.situacao,
        }
      })
      .then(resposta => resposta.body);
  },
  provisoesProjetoExcel: filtros => {
    return Vue.http.get('/api/relatorioprovisoesprojeto/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
          idMetaEtapa: filtros.idMetaEtapa,
          tipo: filtros.tipoProvisao,
          situacao: filtros.situacao,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  rubricasSinteticoExcel: filtros => {
    return Vue.http.get('/api/relatoriorubricas/sintetico/Excel',
      {
        params: filtros,
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  rubricasAnaliticoExcel: filtros => {
    return Vue.http.get('/api/relatoriorubricas/analitico/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          idConta: filtros.idConta,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          idMetaEtapa: filtros.idMetaEtapa,
          idRubrica: filtros.idRubrica,
          idSubrubrica: filtros.idSubrubrica,
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
  taxasProjeto: filtros => {
    return Vue.http.get('/api/RelatorioTaxasProjeto',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          situacao: filtros.situacao,
          tipoData: filtros.tipoData
        }
      })
      .then(resposta => resposta.body);
  },
  taxasProjetoExcel: filtros => {
    return Vue.http.get('/api/RelatorioTaxasProjeto/Excel',
      {
        params: {
          idProjeto: filtros.idProjeto,
          dataInicio: moment(filtros.dataInicio, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          dataFim: moment(filtros.dataFim, 'DD/MM/YYYY').format('MM/DD/YYYY'),
          situacao: filtros.situacao,
          tipoData: filtros.tipoData
        },
        responseType: 'blob',
      })
      .then(response => {
        if (response.body === '') return '';

        return salvarArquivo(response);
      });
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/relatorio/relatorio.servico.js